import {
  GET_AVAILABLE_PORTFOLIOS,
  GET_AVAILABLE_HOLDINGS,
  GET_AVAILABLE_PEER_GROUPS
} from 'hooks/useApi';

const lookupEndpoints = {
  1: GET_AVAILABLE_PORTFOLIOS(),
  2: GET_AVAILABLE_PEER_GROUPS(),
  3: GET_AVAILABLE_HOLDINGS()
};

export default lookupEndpoints;
